import { GetApiMerchantCaseBatchStatusResponse } from '@/services/ytt_apis/apiMerchant/case';
import { useState } from 'react';

export default function useAddCasesDataSource() {
  const [dataSource, setDataSource] = useState<GetApiMerchantCaseBatchStatusResponse['data']>({});

  return {
    dataSource: dataSource || {},
    updateDataSource: setDataSource,
  };
}
